module.exports = __webpack_public_path__ + "static/media/slider-2.74641a0e.png";